// main.js

import { initMobileMenu } from '../components/mobile-menu.js';



export function onReady() {

    console.log('onReady')

    initMobileMenu({
        toggleSelector: '.nav-toggle',
        menuSelector: '.mobile-menu',
        closeSelector: '.mobile-menu-close'
    });

}    